module.exports = __webpack_public_path__ + "static/media/portfolio1 (50).498c5214.jpeg";